import React, { useEffect, useContext, useState, useRef } from "react";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../BaseUrl";

//functions
import {
  _t,
  getCookie,
  formatPrice,
  getSystemSettings,
  customStyle,
} from "../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//3rd party packages
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Moment from "react-moment";
import moment from "moment";
import Select from "react-select";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

//pages & includes
import ReportSidebar from "./ReportSidebar";

//context consumer
import { SettingsContext } from "../../../../contexts/Settings";
import { UserContext } from "../../../../contexts/User";
import { RestaurantContext } from "../../../../contexts/Restaurant";
import CustomSpinLoader from "../../../components/CustomSpinLoader";

const GrnGroupBy = [
  { id: 1, name: "Branch" },
  { id: 2, name: "Supplier" },
  { id: 3, name: "Document Date" },
  { id: 4, name: "Document No" },
];

const GRNReport = () => {
  const { t } = useTranslation();
  //getting context values here
  let { loading, dataPaginating, setDataPaginating, generalSettings } =
    useContext(SettingsContext);
  const { authUserInfo, supplierForSearch, getSupplier } = useContext(UserContext);
  const { branchForSearch } = useContext(RestaurantContext);

  //all data
  const [reportData, setReportData] = useState(null);
  const [reportSummaryData, setReportSummaryData] = useState(null);

  const componentRef = useRef();
  const componentRef1 = useRef();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [generatedReport, setGeneratedReport] = useState(false);

  const [siteName, setSiteName] = useState("");
  const [newReport, setNewReport] = useState({
    branch: null,
    supplier: null,
    groupBy: GrnGroupBy[0],
    type: "detail"
  });

  useEffect(() => {
    if (generalSettings) {
      setSiteName(getSystemSettings(generalSettings, "siteName"));
    }
    if(generalSettings && !supplierForSearch){
      getSupplier()
    }
  }, [generalSettings]);

  const handleBranch = (branch) => {
    setNewReport({
      ...newReport,
      branch: branch,
    });
  };

  const handleSupplier = (supplier) => {
    setNewReport({
      ...newReport,
      supplier,
    });
  };

  const handleGrpBy = (groupBy) => {
    setNewReport({
      ...newReport,
      groupBy,
    });
  };

  const handleReportOption = (e) => {
    setNewReport({
      ...newReport,
      type: e.target.value,
    });
  };

  //get BranchWise reports filter
  const getGrnReport = () => {
    setReportData(null);
    if (
      (authUserInfo.details.user_type === "staff" || authUserInfo.details.user_type === "manager") &&
      !newReport?.branch?.[0]
    ) {
      toast.error(`${_t(t("Please select branch to generate report"))}`, {
        position: "bottom-center",
        closeButton: false,
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
      return;
    }

    if (startDate !== null && endDate !== null && newReport.groupBy) {
      setDataPaginating(true);
      let fromDate = moment(startDate).format("YYYY-MM-DD");
      let toDate = moment(endDate).format("YYYY-MM-DD");

      const url = BASE_URL + "/settings/get-goodsrecieved-report";

      const branch = newReport.branch?.length ? JSON.stringify(newReport.branch.map((branch) => branch.id)) : "";
      let formData = new FormData();
      formData.append("fromDate", fromDate);
      formData.append("toDate", toDate);
      formData.append("type", newReport.type);
      formData.append("branch_id", branch);
      formData.append("supplier_id", newReport.supplier?.id ? newReport.supplier?.id : "");
      formData.append("group_by", newReport.groupBy?.name ? newReport.groupBy?.name : "");

      return axios
        .post(url, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        })
        .then((res) => {
          setGeneratedReport(true);
          if (newReport.type === "detail") {
            setReportData(res.data);
            componentRef.current.handleDownload();
          } else {
            setReportSummaryData(res.data);
            componentRef1.current.handleDownload();
          }
          setDataPaginating(false);
          setNewReport({
            branch: null,
            supplier: null,
            groupBy: GrnGroupBy[0],
            type: "detail"
          });
        })
        .catch((error) => {
          setDataPaginating(false);
        });
    } else {
      toast.error(`${_t(t("Please select from date, to date and group by"))}`, {
        position: "bottom-center",
        closeButton: false,
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
    }
  };

  let g_amount = 0;
  let g_tax = 0;
  let g_dis = 0;
  let g_total = 0;

  let g_amount1 = 0;
  let g_tax1 = 0;
  let g_dis1 = 0;
  let g_total1 = 0;

  return (
    <>
      <Helmet>
        <title>{_t(t("Goods Recieved Notes Report"))}</title>
      </Helmet>
      <ReactHTMLTableToExcel
        id="test-table-xls-button"
        className="download-table-xls-button btn btn-success float-right mr-3 invisible"
        table="table-to-xls"
        filename="Grn Report"
        sheet="sheet 1"
        buttonText="Grn Detail"
        ref={componentRef}
      />

      <ReactHTMLTableToExcel
        id="test-table-xls-button"
        className="download-table-xls-button btn btn-success float-right mr-3 invisible"
        table="table-to-xls1"
        filename="Grn Summary Report"
        sheet="sheet 1"
        buttonText="Grn Detail"
        ref={componentRef1}
      />

      {/* Print Button */}
      <div className="d-none">
        <div>
          <div className="fk-print">
            <div className="row">
              <div className="col-12">
                {reportData !== null &&
                  reportData !== undefined &&
                  generatedReport === true && (
                    <>
                      <div className="row gx-2 justify-content-center t-pb-15 t-pt-15 report">
                        <div className="col-12 t-mb-15 mb-md-0 table-responsive">
                          <table
                            className="table table-bordered table-hover min-table-height mt-3"
                            id="table-to-xls"
                          >
                            <thead className="align-middle">
                              <tr style={{ border: "0px" }}>
                                <th colspan="19" style={{ border: "0px" }}>
                                  <div className="row">
                                    <div className="col-12">
                                      <h3 className="text-center mb-0">
                                        {siteName}
                                      </h3>
                                      <h3 className="text-center mt-0">
                                        Goods Recieved Report
                                      </h3>
                                      <p className="text-center">
                                        FROM&nbsp;
                                        <Moment format="LL">{startDate}</Moment>
                                        &nbsp;TO&nbsp;
                                        <Moment format="LL">{endDate}</Moment>
                                      </p>
                                    </div>
                                  </div>
                                </th>
                              </tr>
                              <tr>
                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Branch"))}
                                </th>
                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("S/L"))}
                                </th>
                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Document No"))}
                                </th>
                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Document Date"))}
                                </th>
                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Po Delivery Date"))}
                                </th>
                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Document Ref Id"))}
                                </th>
                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Branch"))}
                                </th>
                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Supplier"))}
                                </th>
                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Item"))}
                                </th>
                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Unit"))}
                                </th>
                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Po Qty"))}
                                </th>
                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Balance Qty"))}
                                </th>
                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Grn Qty"))}
                                </th>
                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Rate"))}
                                </th>
                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Gross Amount"))}
                                </th>

                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Tax"))}
                                </th>

                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Discount"))}
                                </th>

                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Net Amount"))}
                                </th>
                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Status"))}
                                </th>
                              </tr>
                            </thead>
                            <tbody className="align-middle">
                              {/* loop here*/}
                              {reportData &&
                                Object.keys(reportData).map((group, i) => {
                                  let amount = 0;
                                  let tax = 0;
                                  let dis = 0;
                                  let total = 0;
                                  return (
                                    <>
                                      <tr key={i}>
                                        <th>{group}</th>
                                      </tr>
                                      {reportData[group] &&
                                        reportData[group].map((item, i) => {
                                          g_amount += Number(item.amount);
                                          g_tax += Number(item.tax);
                                          g_dis += Number(item.discount);
                                          g_total += Number(item.total);
                                          amount += Number(item.amount);
                                          tax += Number(item.tax);
                                          dis += Number(item.discount);
                                          total += Number(item.total);
                                          return (
                                            <tr key={i}>
                                              <td></td>
                                              <td scope="row">{i + 1}</td>
                                              <td scope="row">
                                                {item.document_identity}
                                              </td>
                                              <td scope="row">
                                                <Moment format="LL">
                                                  {item.purchase_date}
                                                </Moment>
                                              </td>
                                              <td scope="row">
                                                <Moment format="LL">
                                                  {item.po_delivery_date}
                                                </Moment>
                                              </td>
                                              <td>{item.ref_document_identity}</td>
                                              <td>{item.branch_name}</td>
                                              <td scope="row">
                                                {item.supplier_name}
                                              </td>
                                              <td scope="row">
                                                {item.item_name}
                                              </td>
                                              <td scope="row">{item.unit}</td>
                                              <td>{item.po_qty}</td>
                                              <td>{item.balance_qty}</td>
                                              <td scope="row">{item.qty}</td>
                                              <td scope="row">{item.rate}</td>
                                              <td scope="row">{item.amount}</td>
                                              <td scope="row">{item.tax}</td>
                                              <td scope="row">
                                                {item.discount}
                                              </td>
                                              <td scope="row">{item.total}</td>
                                              <td scope="row">{item.status}</td>
                                            </tr>
                                          );
                                        })}
                                      <tr>
                                        <td colSpan={13} scope="row"></td>
                                        <th scope="row">Total</th>
                                        <td scope="row">
                                          <strong>{amount}</strong>
                                        </td>
                                        <td scope="row">
                                          <strong>{tax}</strong>
                                        </td>
                                        <td scope="row">
                                          <strong>{dis}</strong>
                                        </td>
                                        <td scope="row">
                                          <strong>{total}</strong>
                                        </td>
                                      </tr>
                                    </>
                                  );
                                })}
                              <tr></tr>  
                              <tr>
                                <td colSpan={13} scope="row"></td>
                                <th scope="row">Grand Total</th>
                                <td scope="row">
                                  <strong>{g_amount}</strong>
                                </td>
                                <td scope="row">
                                  <strong>{g_tax}</strong>
                                </td>
                                <td scope="row">
                                  <strong>{g_dis}</strong>
                                </td>
                                <td scope="row">
                                  <strong>{g_total}</strong>
                                </td>
                              </tr>
                            </tbody>
                            <tfoot style={{ border: "0px" }}>
                              <tr style={{ border: "0px" }}>
                                <td
                                  colspan="10"
                                  className="text-center"
                                  style={{ border: "0px" }}
                                >
                                  <h5 className="mt-3">Powered by indolj.pk</h5>
                                </td>
                              </tr>
                            </tfoot>
                          </table>
                        </div>
                      </div>
                    </>
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Print Button */}
      <div className="d-none">
        <div>
          <div className="fk-print">
            <div className="row">
              <div className="col-12">
                {reportSummaryData !== null &&
                  reportSummaryData !== undefined &&
                  generatedReport === true && (
                    <>
                      <div className="row gx-2 justify-content-center t-pb-15 t-pt-15 report">
                        <div className="col-12 t-mb-15 mb-md-0 table-responsive">
                          <table
                            className="table table-bordered table-hover min-table-height mt-3"
                            id="table-to-xls1"
                          >
                            <thead className="align-middle">
                              <tr style={{ border: "0px" }}>
                                <th colspan="12" style={{ border: "0px" }}>
                                  <div className="row">
                                    <div className="col-12">
                                      <h3 className="text-center mb-0">
                                        {siteName}
                                      </h3>
                                      <h3 className="text-center mt-0">
                                        Goods Recieved Summary Report
                                      </h3>
                                      <p className="text-center">
                                        FROM&nbsp;
                                        <Moment format="LL">{startDate}</Moment>
                                        &nbsp;TO&nbsp;
                                        <Moment format="LL">{endDate}</Moment>
                                      </p>
                                    </div>
                                  </div>
                                </th>
                              </tr>
                              <tr>
                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Branch"))}
                                </th>
                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("S/L"))}
                                </th>
                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Document No"))}
                                </th>
                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Document Date"))}
                                </th>
                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("PO Delivery Date"))}
                                </th>
                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Document Ref Id"))}
                                </th>
                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Branch"))}
                                </th>
                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Gross Amount"))}
                                </th>

                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Tax"))}
                                </th>

                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Discount"))}
                                </th>

                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Net Amount"))}
                                </th>

                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Status"))}
                                </th>
                              </tr>
                            </thead>
                            <tbody className="align-middle">
                              {/* loop here*/}
                              {reportSummaryData &&
                                Object.keys(reportSummaryData).map((group, i) => {
                                  let amount = 0;
                                  let tax = 0;
                                  let dis = 0;
                                  let total = 0;
                                  return (
                                    <>
                                      <tr key={i}>
                                        <th>{group}</th>
                                      </tr>
                                      {reportSummaryData[group] &&
                                        reportSummaryData[group].map((item, i) => {
                                          g_amount1 += Number(
                                            item.total_amount
                                          );
                                          g_tax1 += Number(item.total_tax);
                                          g_dis1 += Number(item.total_discount);
                                          g_total1 += Number(item.net_amount);
                                          amount += Number(item.total_amount);
                                          tax += Number(item.total_tax);
                                          dis += Number(item.total_discount);
                                          total += Number(item.net_amount);
                                          return (
                                            <tr key={i}>
                                              <td></td>
                                              <td scope="row">{i + 1}</td>
                                              <td scope="row">
                                                {item.document_identity}
                                              </td>
                                              <td scope="row">
                                                <Moment format="LL">
                                                  {item.purchase_date}
                                                </Moment>
                                              </td>
                                              <td scope="row">
                                                <Moment format="LL">
                                                  {item.po_delivery_date}
                                                </Moment>
                                              </td>
                                              <td>{item.ref_document_identity}</td>
                                              <td>{item.branch_name}</td>
                                              <td scope="row">
                                                {item.total_amount}
                                              </td>
                                              <td scope="row">
                                                {item.total_tax}
                                              </td>
                                              <td scope="row">
                                                {item.total_discount}
                                              </td>
                                              <td scope="row">
                                                {item.net_amount}
                                              </td>
                                              <td scope="row">
                                                {item.status}
                                              </td>
                                            </tr>
                                          );
                                        })}
                                      <tr>
                                        <td colSpan={6} scope="row"></td>
                                        <th scope="row">Grand Total</th>
                                        <td scope="row">
                                          <strong>{amount}</strong>
                                        </td>
                                        <td scope="row">
                                          <strong>{tax}</strong>
                                        </td>
                                        <td scope="row">
                                          <strong>{dis}</strong>
                                        </td>
                                        <td scope="row">
                                          <strong>{total}</strong>
                                        </td>
                                      </tr>  
                                    </>
                                  );
                                })}
                              <tr></tr>  
                              <tr>
                                <td colSpan={6} scope="row"></td>
                                <th scope="row">Total</th>
                                <td scope="row">
                                  <strong>{g_amount1}</strong>
                                </td>
                                <td scope="row">
                                  <strong>{g_tax1}</strong>
                                </td>
                                <td scope="row">
                                  <strong>{g_dis1}</strong>
                                </td>
                                <td scope="row">
                                  <strong>{g_total1}</strong>
                                </td>
                              </tr>
                            </tbody>
                            <tfoot style={{ border: "0px" }}>
                              <tr style={{ border: "0px" }}>
                                <td
                                  colspan="10"
                                  className="text-center"
                                  style={{ border: "0px" }}
                                >
                                  <h5 className="mt-3">Powered by indolj.pk</h5>
                                </td>
                              </tr>
                            </tfoot>
                          </table>
                        </div>
                      </div>
                    </>
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ReportSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div
                  className="fk-scroll--pos-menu table-bottom-info-hide"
                  data-simplebar
                >
                  <div className="t-pl-15 t-pr-15">
                    {/* next page data spin loading */}
                    <CustomSpinLoader loading={loading || dataPaginating}/>

                    {/* spin loading ends */}

                    {/* Loading effect {loading === true ? (
                      tableLoading()
                    ) : ( */}

                    <div key="smtp-form">
                      <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                        <div className="col-12 t-mb-15 mb-md-0">
                          <ul className="t-list fk-breadcrumb">
                            <li className="fk-breadcrumb__list">
                              <span className="t-link fk-breadcrumb__link text-capitalize">
                                {_t(t("Goods Recieved Notes Report"))}
                              </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="row gx-2 mt-2">
                        <div className="col-2">
                          <DatePicker
                            selected={startDate}
                            onChange={(date) => setStartDate(date)}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control sm-text py-2 t-mb-15 mb-md-0"
                            placeholderText={_t(t("From date"))}
                            shouldCloseOnSelect={false}
                          />
                        </div>
                        <div className="col-2 t-mb-15 mb-md-0">
                          <DatePicker
                            selected={endDate}
                            onChange={(date) => setEndDate(date)}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control sm-text py-2"
                            placeholderText={_t(t("To date"))}
                            shouldCloseOnSelect={false}
                          />
                        </div>

                        <div className="col-2 t-mb-15 mb-md-0">
                          <Select
                            options={branchForSearch ? branchForSearch : []}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            classNamePrefix="select"
                            value={newReport.branch || ""}
                            className="table-text"
                            styles={customStyle}
                            isMulti
                            isClearable
                            onChange={handleBranch}
                            maxMenuHeight="200px"
                            placeholder={_t(t("Select branch")) + ".."}
                          />
                        </div>

                        <div className="col-2 t-mb-15 mb-md-0">
                          <Select
                            options={supplierForSearch ? supplierForSearch : []}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            classNamePrefix="select"
                            value={newReport.supplier || ""}
                            className="table-text"
                            styles={customStyle}
                            onChange={handleSupplier}
                            maxMenuHeight="200px"
                            placeholder={_t(t("Select supplier")) + ".."}
                            isClearable
                          />
                        </div>

                        <div className="col-2 t-mb-15 mb-md-0">
                          <Select
                            options={GrnGroupBy ? GrnGroupBy : []}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            classNamePrefix="select"
                            value={newReport.groupBy || ""}
                            className="table-text"
                            styles={customStyle}
                            onChange={handleGrpBy}
                            maxMenuHeight="200px"
                            placeholder={_t(t("Select group")) + ".."}
                          />
                        </div>

                        <div className="col-2">
                          <div style={{marginTop:"-0.8rem"}} className="d-flex align-items-center">
                            <input
                              type="radio"
                              className="form-check-input pointer-cursor"
                              id="detail"
                              name="detail"
                              value="detail"
                              onChange={(e) => {
                                handleReportOption(e);
                              }}
                              checked={newReport.type === "detail"}
                            />
                            <label
                              className="form-radio-label pointer-cursor ml-2 pt-1"
                              htmlFor="detail"
                            >
                              {_t(t("Detail Report"))}
                            </label>
                          </div>
                          <div className="mt-1 d-flex align-items-center">
                            <input
                              type="radio"
                              className="form-check-input pointer-cursor"
                              id="summary"
                              name="summary"
                              value="summary"
                              onChange={(e) => {
                                handleReportOption(e);
                              }}
                              checked={newReport.type === "summary"}
                            />
                            <label
                              className="form-radio-label pointer-cursor ml-2 pt-1"
                              htmlFor="summary"
                            >
                              {_t(t("Summary Report"))}
                            </label>
                          </div>
                        </div>

                        <div className="col-10"></div>

                        <div className="col-2 mt-2">
                          <button
                            className="float-right btn btn-block btn-primary text-uppercase sm-text py-2 rounded"
                            onClick={(e) => getGrnReport(e)}
                          >
                            Grn Report
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Rightbar contents end*/}
          </div>
        </div>
      </main>
    </>
  );
};

export default GRNReport;
